// extracted by mini-css-extract-plugin
export default {"btn_add_clear":"ModalAddWallet_btn_add_clear__IPcDY","errorText":"ModalAddWallet_errorText__QM+s7"};